<template>
  <ListLayout
    :title="`${configurationModule.paymentMethod}`"
    :context="context"
    :tableData="paymentMethodList"
    :tableHeader="tableHeaders"
    :total="totalItem"
    @getList="getPaymentMethodList"
  >
    <template #listAction>
      <PrimaryButton
        id="paymentMethodAdd"
        v-if="permissions && permissions.add"
        @click="addPaymentMethod"
        :name="`Add ${configurationModule.paymentMethod}`"
        icon="mdi-plus"
        iconSize="x-large"
      >
      </PrimaryButton>
    </template>
    <template #dialogs>
      <PaymentMethodForm
        :editMode="isEditing"
        :id="selectedPaymentMethodID"
        v-model="showPaymentMethodForm"
        @refreshList="getPaymentMethodList"
      />
    </template>
  </ListLayout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import PaymentMethodButton from "@/components/Button/PaymentMethodButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import PaymentMethodForm from "@/components/ModuleBasedComponents/PaymentMethod/PaymentMethodForm.vue";
import { configurationModule } from "@/utils/moduleMapping";

export default {
  components: {
    PaymentMethodButton,
    ListLayout,
    PaymentMethodForm,
  },
  data() {
    return {
      configurationModule,
      permissions: null,
      sorting: {},
      totalItem: 0,
      filters: {},
      paymentMethodList: [],
      headerSelected: [
        {
          headerName: "Name",
          field: "name",
          sortable: true,
        },
        {
          headerName: "type",
          field: "type",
          sortable: true,
          cellRenderer: (params) => {
            if (params && params.data && params.data.type) {
              return params.data.type.replace(/_/g, " ");
            }
          },
        },
      ],

      isEditing: false,
      showPaymentMethodForm: false,
      selectedPaymentMethodID: null,
    };
  },
  computed: {
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 100,
          sortable: false,
          width: 100,
          cellRenderer: "PaymentMethodButton",
        },
      ];
    },
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    getPaymentMethodList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        limit: this.$globalConstant.itemsPerPage,
        offset: 0,
        ...params,
        ...this.filters,
      };

      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }

      this.$api.paymentMethod
        .getPaymentMethodList(params)
        .then((res) => {
          this.paymentMethodList = res.data;
          this.totalItem = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    addPaymentMethod() {
      this.selectedPaymentMethodID = null;
      this.isEditing = false;
      this.showPaymentMethodForm = true;
    },
    editPaymentMethod(id) {
      this.selectedPaymentMethodID = id;
      this.isEditing = true;
      this.showPaymentMethodForm = true;
    },
  },
  mounted() {
    this.getPaymentMethodList();
  },
  created() {
    this.permissions = this.$permissions.getPermission("configuration");
  },
};
</script>
